import { Context, Emitter, Tag } from '..'

export default class extends Tag {
  render (ctx: Context, _emitter: Emitter) {
    ctx.breakCalled = true
  }
}
